interface Props {
	cancel?: () => void
	save?: () => void
	publish?: () => void
}

const SaveButtonGroup: React.FC<Props> = ({ cancel, save, publish }) => {
	return (
		<div
			className="d-flex flex-column flex-xl-row justify-content-end align-items-center"
			style={{ gap: '12px' }}>
			{/* Cancel, Save */}
			<div className="w-sm-100 d-flex flex-row" style={{ gap: '12px' }}>
				<button
					className="btn btn-sm white-button text-kumopack-grey-700 fw-bold w-sm-50"
					onClick={cancel}>
					<img
						className="me-1"
						src="/media/icons/kumopack/black-save-01.svg"
						alt="Black Save Icon"
					/>
					ยกเลิก
				</button>
				<button
					className="btn btn-sm white-button text-kumopack-grey-700 fw-bold w-sm-50"
					onClick={save}>
					<img
						className="me-1"
						src="/media/icons/kumopack/black-save-01.svg"
						alt="Black Save Icon"
					/>
					บันทึกเก็บไว้
				</button>
			</div>

			{/* Save and Publish */}
			<div className="w-sm-100">
				<button
					className="btn btn-sm btn-kumopack-secondary-600 text-kumopack-base-white fw-bold w-sm-100"
					onClick={publish}>
					<img
						className="me-1"
						src="/media/icons/kumopack/white-save-01.svg"
						alt="Black Save Icon"
					/>
					บันทึกและเผยแพร่
				</button>
			</div>
		</div>
	)
}

export default SaveButtonGroup
